import { render, staticRenderFns } from "./MemberTypeDetailsModal.vue?vue&type=template&id=31bd774f&"
import script from "./MemberTypeDetailsModal.vue?vue&type=script&lang=js&"
export * from "./MemberTypeDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31bd774f')) {
      api.createRecord('31bd774f', component.options)
    } else {
      api.reload('31bd774f', component.options)
    }
    module.hot.accept("./MemberTypeDetailsModal.vue?vue&type=template&id=31bd774f&", function () {
      api.rerender('31bd774f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MemberTypeDetailsModal.vue"
export default component.exports